import script from "./preview.vue?vue&type=script&setup=true&lang=js"
export * from "./preview.vue?vue&type=script&setup=true&lang=js"

import "./preview.vue?vue&type=style&index=0&id=1e094ff2&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e094ff2"]])

export default __exports__